/**
 * This functions checks if the environment (browser)
 * supports our language features
 */

export const isSupportedEnvironment = () => !!Array.prototype.toSorted;
